import { Plugin } from '@jeppesen-foreflight/jmkw-types';
import { ViewToggleButtonComponent } from './view-toggle-button/view-toggle-button.component';

export const VIEW_TOGGLE_PLUGIN: Plugin = new Plugin({
  id: 'view-toggle',
  button: { buttonComponent: ViewToggleButtonComponent }
});
